import React from 'react';
import { Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import styles from './style.less';

const ArrayFieldTemplate = (props) => {
  const {
    title, items, canAdd, onAddClick,
  } = props;

  return (
    <div className={`ant-row mb-3 array`}>
      <div className={`ant-form-item-label ant-col-sm-24 ant-col-md-7`}>
        <label>{title}</label>
      </div>
      <div className={`ant-row ant-col-sm-24 ant-col-xxl-10 ant-col-xl-17 ant-col-lg-17 ant-col-lg-17`}>
        {items.map((element, index) => {
          if (element.children.length || element.children.length === 0) {
            return element.children.map(entry => (
              React.cloneElement(entry, { isArrayObject: true, arr: true, key: (entry.id || index) })
            ));
          }

          return (
            <div key={element.id || index} className={`ant-row ant-col-md-24 ${styles.row}`}>
              <div className={styles.firstCol}>
                {React.cloneElement(element.children, {
                  schema: {
                    ...element.children.props.schema,
                    isArrayObject: true,
                  },
                })}
              </div>
              <div className={styles.secondCol}>
                <Icon type="minus-circle-o" className={styles.delete} onClick={element.onDropIndexClick(element.index)} />
              </div>
            </div>);
        })}
        {canAdd && <Button type="dashed" style={{ width: '100%', marginBottom: 15 }} onClick={onAddClick}>Өнгө нэмэх</Button>}
      </div>
    </div>
  );
};

ArrayFieldTemplate.defaultProps = {
  title: '',
  items: [],
  canAdd: true,
};

ArrayFieldTemplate.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  canAdd: PropTypes.bool,
  onAddClick: PropTypes.func.isRequired,
};

export default ArrayFieldTemplate;



// WEBPACK FOOTER //
// ./src/components/Form/FieldTemplates/ArrayFieldTemplate/index.js